<script setup lang="ts">
import { ref, computed } from 'vue';
import { useAppStore } from '../stores/app';
import { contactInfo, socialLinks } from '../data/portfolio';

const appStore = useAppStore();

const formData = ref({
  name: '',
  email: '',
  subject: '',
  message: ''
});

const contactItems = computed(() => [
  { icon: 'fa-envelope', label: appStore.isZh ? '邮箱' : 'Email', value: contactInfo.email },
  { icon: 'fa-map-marker-alt', label: appStore.isZh ? '地址' : 'Address', value: contactInfo.address },
  { icon: 'fa-qq', label: 'QQ', value: contactInfo.qq },
  { icon: 'fa-weixin', label: appStore.isZh ? '微信' : 'WeChat', value: contactInfo.wechat },
  { icon: 'fa-briefcase', label: appStore.isZh ? '钉钉' : 'DingTalk', value: contactInfo.dingtalk }
]);

function handleSubmit() {
  const subject = encodeURIComponent(formData.value.subject);
  const body = encodeURIComponent(
    `${appStore.isZh ? '姓名' : 'Name'}: ${formData.value.name}\n${appStore.isZh ? '邮箱' : 'Email'}: ${formData.value.email}\n\n${formData.value.message}`
  );
  window.location.href = `mailto:${contactInfo.email}?subject=${subject}&body=${body}`;
}
</script>

<template>
  <section id="contact" class="contact-section section">
    <div class="container">
      <h2 class="section-title">
        <i class="fas fa-envelope"></i>
        {{ appStore.isZh ? '联系我' : 'Contact Me' }}
      </h2>
      <div class="section-divider"></div>
      <p class="section-subtitle">
        {{ appStore.isZh 
          ? '若有项目合作或技术交流，欢迎随时联系吾' 
          : 'Feel free to reach out for project collaborations or tech discussions' }}
      </p>

      <div class="contact-content">
        <div class="contact-info glass-card">
          <h3 class="info-title">
            <i class="fas fa-address-card"></i>
            {{ appStore.isZh ? '联系方式' : 'Contact Info' }}
          </h3>
          
          <div class="info-list">
            <div 
              v-for="item in contactItems" 
              :key="item.label"
              class="info-item"
            >
              <div class="info-icon">
                <i :class="['fas', item.icon]"></i>
              </div>
              <div class="info-details">
                <span class="info-label">{{ item.label }}</span>
                <span class="info-value">{{ item.value }}</span>
              </div>
            </div>
          </div>

          <div class="social-section">
            <h4 class="social-title">
              <i class="fas fa-share-alt"></i>
              {{ appStore.isZh ? '社交媒体' : 'Social Media' }}
            </h4>
            <div class="social-links">
              <a
                v-for="link in socialLinks"
                :key="link.name"
                :href="link.url"
                target="_blank"
                rel="noopener noreferrer"
                class="social-link"
                :title="link.name"
              >
                <i :class="['fab', link.icon]"></i>
              </a>
            </div>
          </div>
        </div>

        <form class="contact-form glass-card" @submit.prevent="handleSubmit">
          <h3 class="form-title">
            <i class="fas fa-paper-plane"></i>
            {{ appStore.isZh ? '发送消息' : 'Send Message' }}
          </h3>
          
          <div class="form-group">
            <label>{{ appStore.isZh ? '姓名' : 'Name' }}</label>
            <input 
              v-model="formData.name"
              type="text" 
              required
              :placeholder="appStore.isZh ? '请输入您的姓名' : 'Enter your name'"
            />
          </div>

          <div class="form-group">
            <label>{{ appStore.isZh ? '邮箱' : 'Email' }}</label>
            <input 
              v-model="formData.email"
              type="email" 
              required
              :placeholder="appStore.isZh ? '请输入您的邮箱' : 'Enter your email'"
            />
          </div>

          <div class="form-group">
            <label>{{ appStore.isZh ? '主题' : 'Subject' }}</label>
            <input 
              v-model="formData.subject"
              type="text" 
              required
              :placeholder="appStore.isZh ? '请输入消息主题' : 'Enter the subject'"
            />
          </div>

          <div class="form-group">
            <label>{{ appStore.isZh ? '消息' : 'Message' }}</label>
            <textarea 
              v-model="formData.message"
              rows="5" 
              required
              :placeholder="appStore.isZh ? '请输入您的消息...' : 'Enter your message...'"
            ></textarea>
          </div>

          <button type="submit" class="nezha-btn nezha-btn-primary w-full">
            <i class="fas fa-paper-plane"></i>
            {{ appStore.isZh ? '发送消息' : 'Send Message' }}
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import '../styles/components/contact.css';
</style>
